import { ColoresService } from './../../core/services/utils/colores.service';
import { AuthService } from './../../core/services/auth/auth.service';
import { LocalService } from './../../core/services/storage/local.service';
import { SweetAlertService } from './../../core/services/utils/sweet-alert.service';
import { CustomerService } from './../../core/services/http/customer.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
  customer: any;

  constructor(
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private sweetAlertService: SweetAlertService,
    private router: Router,
    private localSecureService: LocalService,
    private authService: AuthService,
    private colores: ColoresService
  ) { }

  ngOnInit(): void {

    if (navigator.userAgent.indexOf('Chrome') !== -1 && !(navigator.userAgent.indexOf('Android') !== -1)) {
      if (!Notification) {
        console.log('Desktop notifications are not available in your browser.');
        return;
      }

      if (Notification.permission !== 'granted') {
        Notification.requestPermission();
      }
    }

    const guId = this.route.snapshot.paramMap.get("id");
    if (guId) {
      this.localSecureService.removeItem('valores');
      this.getCustomer(guId);
    }
  }

  async getCustomer(id: any) {
    this.customer = await this.customerService.getCustomer(id);
    if (this.customer) {
      if (this.customer.status == false) {
        this.sweetAlertService.swalErrorLogin(
          '¡Lo sentimos!',
          'Acceso no permitido',
          'Intente nuevamente...')
      } else {
        const parametros = JSON.parse(this.customer[0].parametros);
        const colorestotem = parametros.colorestotem;
        this.localSecureService.setValue('validated', true);
        this.localSecureService.setValue('customer', this.customer[0]);
        //this.estilos(colorestotem);
        this.colores.estilos(colorestotem);
        this.localSecureService.setValue('valores', colorestotem)
        this.localSecureService.setValue('parametros', parametros)
        this.router.navigate([this.customer[0].slug, 'login']);
      }
    } else {
      this.sweetAlertService.swal500();
    }
  }

}
